import React from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import Profile from '../../components/profile';
import Notification from '../../components/Notification';
import Trolly from '../../components/Trolly';
import UpdatePassword from '../../components/updatePassword';
import "../../css/profile.css"



export default function UpdatePasswordPage() {
  const [userData, setUser] = React.useState({});


  return (
    <div>
      <Navbar userData={setUser} logReg={<Profile userData={userData}/>} notification={<Notification />} trolly={<Trolly />} />
      <UpdatePassword/>
      <Footer />
    </div>
  );
}
